import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/file-based/:examId/attempts/:attemptId/publish`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const finish = {
  post: apiPathFunc(pathBase),
} as const;
